import * as React from "react";
import type { SVGProps } from "react";
const SvgVolume2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 5h1a1 1 0 0 0-1.625-.78zM6 9v1a1 1 0 0 0 .625-.22zM2 9V8a1 1 0 0 0-1 1zm0 6H1a1 1 0 0 0 1 1zm4 0 .625-.78A1 1 0 0 0 6 14zm5 4-.625.78A1 1 0 0 0 12 19zm8.777-14.777a1 1 0 1 0-1.414 1.414zm-1.414 14.14a1 1 0 1 0 1.414 1.414zm-2.116-10.61a1 1 0 1 0-1.414 1.414zm-1.414 7.07a1 1 0 1 0 1.414 1.414zM10.375 4.219l-5 4 1.25 1.562 5-4zM6 8H2v2h4zM1 9v6h2V9zm1 7h4v-2H2zm3.375-.22 5 4 1.25-1.56-5-4zM12 19V5h-2v14zm6.363-13.363A9 9 0 0 1 20.998 12h2a11 11 0 0 0-3.22-7.777zM20.998 12a9 9 0 0 1-2.635 6.363l1.414 1.414A11 11 0 0 0 22.997 12zm-6.165-2.833a4 4 0 0 1 1.17 2.828h2a6 6 0 0 0-1.756-4.242zm1.17 2.828a4 4 0 0 1-1.17 2.828l1.414 1.414a6 6 0 0 0 1.757-4.242z"
    />
  </svg>
);
export default SvgVolume2;
